import { EditProjectContextProps } from "../../../EditProjectContext";

export function removeOdcFromRoute(
  ftlRouteId: number,
  odcRelationId: number,
  editProjectContext: EditProjectContextProps
) {
  const { project, setProject } = editProjectContext;
  const updateFtlRoutes = project?.FTLRoutes?.map((ftlRoute) => {
    if (ftlRoute.RouteId !== ftlRouteId || !ftlRoute.Odcs) {
      return ftlRoute;
    }

    const index = ftlRoute.Odcs.findIndex((x) => x.Id === odcRelationId);
    const odcs = [...ftlRoute.Odcs];
    odcs.splice(index, 1);

    return {
      ...ftlRoute,
      Odcs: odcs,
    };
  });

  setProject({
    ...project,
    FTLRoutes: updateFtlRoutes,
  });
}
